import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Club } from "../../../../interfaces/club";
import { Staff } from "../../../../interfaces/staff";
import { getStaff } from "../../../../services/staff";
import { AdminStaffEdit } from "./staff-edit";
import moment from 'moment';
import { getClubOptions } from "../../../../services/club";
import avatar from "../../../../assets/images/avatar.svg";
import { AdminStaffNew } from "./staff-new";
import { AdminStaffDelete } from "./staff-delete";
import { AdminStaffTeamSeason } from "./staff-team-season";

export function AdminStaffList() {
    const [staff, setStaff] = useState<Staff[]>([]);
    const [clubOptions, setClubOptions] = useState<any[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showStaffTeamSeason, setShowStaffTeamSeason] = useState(false);
    const [selectedId, setSelectedId] = useState(0);

    useEffect(() => {
        getClubOptions()
            .then(response => {
                setClubOptions(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        getStaff()
            .then(response => {
                setStaff(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        const club = event.target.club.value;
        const sortbyfield = event.target.sortbyfield.value;
        const sortbytype = event.target.sortbytype.value;

        getStaff(s, club, '', sortbyfield, sortbytype)
            .then(response => {
                setStaff(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: Staff) => {
        const newStaff = [
            s,
            ...staff
        ];
        setStaff(newStaff);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }

    const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newStaff = staff.filter((m: Staff) => m.id != id);
        setStaff(newStaff);
        setShowDelete(false);
    }

    const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedStaff: Staff) => {
        setSelectedId(0);
        const newStaff = staff.map((m: Staff) => {
            if (m.id == changedStaff.id) {
                return changedStaff;
            } else {
                return m;
            }
        });
        setStaff(newStaff);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    const handleStaffTeamSeason = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowStaffTeamSeason(true);
    }

    const handleStaffTeamSeasonOnSave = (changedStaff: Staff) => {
        setSelectedId(0);
        setShowStaffTeamSeason(false);
    }

    const handleStaffTeamSeasonOnClose = () => {
        setSelectedId(0);
        setShowStaffTeamSeason(false);
    }

    return (
        <div className="staff-list-container">
            <h1>
                { t('Coaches')}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="text" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="club_id">
                        <Form.Select aria-label={ t("club") } name="club">
                            <option value="">{ t("select_club") }</option>
                            { clubOptions.map((c: Club) => {
                                return <option key={ 'club-' + c.id } value={ c.id }>{ c.name }</option>;
                            })}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="sortbyfield">
                        <Form.Select aria-label={ t("Sort by") } name="sortbyfield" defaultValue={ 'updated_at' }>
                            <option value="updated_at">{ t("Sort by updated") }</option>
                            <option value="name">{ t("Sort by name") }</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="sortbytype">
                        <Form.Select aria-label={ t("Sort type") } name="sortbytype" defaultValue={ 'DESC' }>
                            <option value="ASC">{ t("Ascending") }</option>
                            <option value="DESC">{ t("Descending") }</option>
                        </Form.Select>
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="grid-container">
                <Row>
                    { staff.map((s: Staff) => {
                        return <Col key={ 'staff-' + s.id } xs={12} md={6} lg={4} xl={3}>
                            <div className="staff-card">
                                <div className="heading">
                                    <div className="avatar">
                                        { s.avatar.length > 0 &&
                                            <img src={ s.avatar[0].url } alt={ s.name } />
                                        }
                                        { s.avatar.length == 0 &&
                                            <img src={ avatar } alt={ s.name } />
                                        }
                                    </div>
                                    <div className="meta">
                                        <div className="name">
                                            { s.name }
                                        </div>
                                        { s.birthdate &&
                                            <div className="years">
                                                { moment(new Date()).diff(s.birthdate, 'years') + ' ' + t("years").toLowerCase() }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="actions">
                                    <a href="#" className="icon-link edit" title={ t("Edit") } onClick={ handleEdit } data-id={ s.id }>
                                        <i className="bi bi-pencil-square"></i>
                                    </a>
                                    <a href="#" className="icon-link team-season" title={ t("athlete_team_seasons") } onClick={ handleStaffTeamSeason } data-id={ s.id }>
                                        <i className="bi bi-calendar-check"></i>
                                    </a>
                                    <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ s.id }>
                                        <i className="bi bi-trash"></i>
                                    </a>
                                </div>
                            </div>
                        </Col>
                    })}
                </Row>
            </div>
            {<a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a>}
            { showAddNew &&
                <AdminStaffNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            }
            { showEdit && (selectedId != 0) &&
                <AdminStaffEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
            { showStaffTeamSeason && (selectedId != 0) &&
                <AdminStaffTeamSeason id={ selectedId } onSave={ handleStaffTeamSeasonOnSave } onClose={ handleStaffTeamSeasonOnClose } />
            }
            { showDelete && (selectedId != 0) &&
                <AdminStaffDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            }
        </div>

    )
}
